// @flow
import * as React from 'react';

export default React.createContext<{ blurExceptionClassNames?: Array<string> }>({ blurExceptionClassNames: [] });
